import React, { Component } from 'react';
import * as MonthlyMoney from './Saga/MonthlyMoney';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
// import * as Monies from '../../Store/Monies';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns'
import jaLocale from "date-fns/locale/ja";
import ja from "date-fns/locale/ja";

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import { Field} from 'redux-form';
import './Css/Kyousai.css';
import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
const moment = require('moment')
const styles = (theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});
// import DatePicker from "react-datepicker";
let timer: any
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');



class JaLocalizedUtils extends DateFnsUtils {
  // ヘッダ部分のテキストを取得するメソッド
  getDatePickerHeaderText(date: Date) {
    return format(date, 'M月d日(E)', { locale: this.locale })
  }
}


interface Props {
  monthly_money_list: any,
  users_select: any,
  monthly_money_search_list: any,
  monthly_money_search: any,
  change_monthly_money_search: any,
  set_monthly_money_search_list: any,
  user_details: any,
  get_monthly_money_list: any,
}


interface State {
  refresh: boolean,
  name: any,
  tatemono_name: any,
  billing_date1: any,
  billing_date2: any,
  total_money: any

}


class KyousaiSearch extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      refresh: false,
      name: "",
      tatemono_name: "",
      billing_date1: null,
      billing_date2: null,
      total_money: null
    }

    let monthly_money_search = this.props.monthly_money_search
    monthly_money_search.user_id = this.props.user_details.id
    this.props.change_monthly_money_search(monthly_money_search)

    this.onChange = this.onChange.bind(this);


    this.change_shoyuusha_tantou_no = this.change_shoyuusha_tantou_no.bind(this);
    this.change_list = this.change_list.bind(this);
    this.name = this.name.bind(this);
    this.tatemono_name = this.tatemono_name.bind(this);
    this.billing_date1 = this.billing_date1.bind(this);
    this.billing_date2 = this.billing_date2.bind(this);
    this.total_money = this.total_money.bind(this);
    this.search = this.search.bind(this);
  }



  componentWillMount() {



  }




  change_shoyuusha_tantou_no(e: any, newValue: any) {
    let monthly_money_search = this.props.monthly_money_search
    monthly_money_search.shoyuusha_tantou_no = newValue ? newValue.value : 0
    this.props.change_monthly_money_search(monthly_money_search)
    this.props.set_monthly_money_search_list()
  }

  change_list(num: number) {
    let monthly_money_search = this.props.monthly_money_search
    monthly_money_search.flg = num
    if (num === 1) {

      monthly_money_search.week1 = false
    } else if (num === 2) {

      monthly_money_search.week1 = true
    }
    this.props.change_monthly_money_search(monthly_money_search)
    this.props.set_monthly_money_search_list()
  }


  name(e: any) {
    this.setState({
      name: e.target.value
    });
  }
  tatemono_name(e: any) {
    this.setState({
      tatemono_name: e.target.value
    });
  }
  total_money(e: any) {
    this.setState({
      total_money: e.target.value
    });
  }
  billing_date1 = (date: any) => {
    this.setState({
      billing_date1: new Date(date),
    });
  };
  billing_date2 = (date: any) => {
    this.setState({
      billing_date2: new Date(date),
    });
  };
  search(e: any) {
    this.props.get_monthly_money_list({
      name: this.state.name,
      tatemono_name: this.state.tatemono_name,
      billing_date1: this.state.billing_date1,
      billing_date2: this.state.billing_date2,
      total_money: this.state.total_money
    });
  }

  onChange(e: any) {
    // alert(e.target.name)

    if (e.target.name === "tatemono_name") {
      clearTimeout(timer);

      let monthly_money_search = this.props.monthly_money_search
      monthly_money_search.building_name = e.target.value
      this.props.change_monthly_money_search(monthly_money_search)
      timer = setTimeout(() => {

        this.props.set_monthly_money_search_list()
      }, 400);


    } else {
      clearTimeout(timer);
      let monthly_money_search = this.props.monthly_money_search
      monthly_money_search.contractor_name1 = e.target.value
      this.props.change_monthly_money_search(monthly_money_search)
      timer = setTimeout(() => {


        this.props.set_monthly_money_search_list()
      }, 400);


    }
  }
  render() {



    return (
      <div>

        <table style={{ border: "0px" }}>

          <tbody>

            <tr style={{ border: "0px" }}>

              <td style={{ border: "0px" }}>
                <TextField
                  name="name"
                  onChange={this.name}
                  type="text"
                  className="form-control"
                  label="お客様名"
                />

              </td>
              <td style={{ border: "0px" }}>
                <TextField
                  name="tatemono_name"
                  onChange={this.tatemono_name}
                  type="text"
                  label="物件名"
                  className="form-control"
                />
              </td>

              <td style={{ border: "0px" }}>
                <TextField
                  name="total_money"
                  onChange={this.total_money}
                  type="number"
                  label="請求額"
                  className="form-control"
                />
              </td>

              <td style={{ border: "0px" }}>

                {/* 日付選択 */}
                <MuiPickersUtilsProvider utils={JaLocalizedUtils} locale={jaLocale}>
                  <KeyboardDatePicker

                    variant="inline"
                    margin="normal"
                    id="date-picker-dialog"
                    label="請求日"
                    format="yyyy/MM/dd"
                    style={{ width: 130 }}
                    value={this.state.billing_date1}
                    onChange={this.billing_date1}
                    autoOk={true}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>

                <i className="fas fa-long-arrow-alt-right" style={{ verticalAlign: "bottom", margin: 10, fontSize: 20 }}></i>

                {/* 日付選択 */}
                <MuiPickersUtilsProvider utils={JaLocalizedUtils} locale={jaLocale}>
                  <KeyboardDatePicker

                    variant="inline"
                    margin="normal"
                    id="date-picker-dialog"
                    label="請求日"
                    format="yyyy/MM/dd"
                    style={{ width: 130 }}
                    value={this.state.billing_date2}
                    onChange={this.billing_date2}
                    autoOk={true}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>

              </td>
              <td style={{ border: "0px" }}>

                <Button
                  style={{ margin: 5 }}
                  onClick={this.search}
                  variant="outlined" color="primary">
                  検索
                </Button>

                <Chip label={this.props.monthly_money_search_list.length + "件"} style={{ margin: 5 }}
                  clickable color="primary" />
              </td>
            </tr >
          </tbody >
        </table >
      </div >
    );
  }
}




const mapStateToProps = (state: any) => {
  return {
    users_select: state.masterReducer.users_select,

    user_details: state.masterReducer.user_details,


    monthly_money_list: state.MonthlyMoney.monthly_money_list,
    monthly_money_search_list: state.MonthlyMoney.monthly_money_search_list,
    monthly_money_search: state.MonthlyMoney.monthly_money_search,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    change_monthly_money_search(state: any) {
      dispatch(MonthlyMoney.change_monthly_money_search(state))
    },
    set_monthly_money_search_list(state: any) {
      dispatch(MonthlyMoney.set_monthly_money_search_list(state))
    },
    get_monthly_money_list(state: any) {
      dispatch(MonthlyMoney.get_monthly_money_list(state))
    },

  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(KyousaiSearch));

